module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eca17c99b2f66a20a4f0c25048bfc108.png";